import React from "react";
import fields from "../../json/RoleLisrFeilds.json";
import FormInput from "Common/Custom/FormInput";
import FormTextarea from "Common/Custom/FormTextarea";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

const EditRoleForm = ({ values = "0", errors, handleChange, handleSubmit, loading, title = "Update Role" }) => {
  const { formdata } = fields;
  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {formdata.map((field) => {
        if (field.type === "switch") {
          return (
            <Switch
              key={field.name}
              values={values[field.name]}
              handleChange={handleChange}
              field={field}   
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }
        if(field.type === "textarea") {
            return (
              <FormTextarea
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label={`Update`}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditRoleForm;
